<template>
  <v-row
    class="fill-height ma-0"
    align="center"
    justify="center"
  >
    <v-progress-circular indeterminate color="grey lighten-5"/>
  </v-row>
</template>

<script>
export default {
  name: "BaseImageLoading",
}
</script>
